import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b4e2a10")

_pushScopeId("data-v-3b4e2a10")
const _hoisted_1 = {
  class: "toc_ui__baseInfo_main",
  id: "BaseInfo"
}
const _hoisted_2 = { class: "toc_ui__baseInfo_body" }
const _hoisted_3 = { class: "toc_ui__baseInfo_body_cont" }
const _hoisted_4 = { class: "toc_ui__baseInfo_imgList" }
const _hoisted_5 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_componentTitle = _resolveComponent("componentTitle")
  const _component_infoList = _resolveComponent("infoList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_componentTitle, { title: "车辆信息" }, {
          default: _withId(() => [
            _createVNode("span", {
              class: "titleSlot",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goCarInfo && _ctx.goCarInfo(...args)))
            }, "查看更多")
          ]),
          _: 1
        }),
        _createVNode(_component_infoList, {
          dataList: _ctx.state.baseInfo,
          direction: ""
        }, null, 8, ["dataList"]),
        _createVNode("ul", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.photoList.slice(0, 4), (item, index) => {
            return (_openBlock(), _createBlock("li", {
              class: "toc_ui__baseInfo_imgList_item",
              key: item.photoIdStr,
              onClick: ($event: any) => (_ctx.goToImgView(item))
            }, [
              _createVNode("img", {
                class: "toc_ui__baseInfo_imgList_item",
                src: item.smallPhotoUrl
              }, null, 8, ["src"]),
              (_ctx.state.photoList.length > 4 && index === 3)
                ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.state.photoList.length) + "张", 1))
                : _createCommentVNode("", true)
            ], 8, ["onClick"]))
          }), 128))
        ])
      ])
    ])
  ]))
})